module.exports = __webpack_public_path__ + "static/media/kauai.df47ed69.bin";